import {V3Badge, V3BadgeTypeType} from '@wix/ambassador-events-v3-event/types'
import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'
import {BadgeType, EVENT_BADGE_TYPE} from '../utils/event-badges'

export const getEventHighestPriorityBadge = (badges: wix.events.Badge[] | V3Badge[]) => {
  const firstPriorityBadge =
    getEventBadgeByPriority(badges, EVENT_BADGE_TYPE.FIRST_PRIORITY) ||
    getEventBadgeByPriority(badges, V3BadgeTypeType.FIRST_PRIORITY)

  if (firstPriorityBadge) {
    return firstPriorityBadge
  }

  const secondPriorityBadge =
    getEventBadgeByPriority(badges, EVENT_BADGE_TYPE.SECOND_PRIORITY) ||
    getEventBadgeByPriority(badges, V3BadgeTypeType.SECOND_PRIORITY)

  if (secondPriorityBadge) {
    return secondPriorityBadge
  }

  return (
    getEventBadgeByPriority(badges, EVENT_BADGE_TYPE.THIRD_PRIORITY) ||
    getEventBadgeByPriority(badges, V3BadgeTypeType.THIRD_PRIORITY)
  )
}

export const getEventBadgeByPriority = (badges: wix.events.Badge[] | V3Badge[], type: BadgeType | V3BadgeTypeType) => {
  const types: (BadgeType | V3BadgeTypeType)[][] = [
    [EVENT_BADGE_TYPE.FIRST_PRIORITY, V3BadgeTypeType.FIRST_PRIORITY],
    [EVENT_BADGE_TYPE.SECOND_PRIORITY, V3BadgeTypeType.SECOND_PRIORITY],
    [EVENT_BADGE_TYPE.THIRD_PRIORITY, V3BadgeTypeType.THIRD_PRIORITY],
  ]

  const neededTypes = types.find(pair => pair.includes(type))

  return badges
    .filter(badge => neededTypes.includes(badge.type))
    .sort((badgeA, badgeB) => {
      const dateA = badgeA.functionUpdateDate ? new Date(badgeA.functionUpdateDate).getTime() : 0
      const dateB = badgeB.functionUpdateDate ? new Date(badgeB.functionUpdateDate).getTime() : 0

      return dateB - dateA
    })[0]
}

export const getEventBadgeSettingsTitle = (type: EVENT_BADGE) =>
  type === EVENT_BADGE.FIRST_PRIORITY
    ? 'eventBadges_firstPriority_settingsTitle'
    : type === EVENT_BADGE.SECOND_PRIORITY
      ? 'eventBadges_secondPriority_settingsTitle'
      : 'eventBadges_thirdPriority_settingsTitle'
